import React, { useEffect, useState } from "react";
import Header from "src/Home/Header";
import Form from "src/Home/Form";
import JoinGroup from "src/Home/JoinGroup";
import Footer from "src/Home/Footer";
import useAccount from "src/hooks/useAccount";
import useChainId from "src/hooks/useChainId";
import { workingNetwork } from "src/hooks/address";
import { getOwner } from "src/hooks/operations";

export default function Home() {
  const account = useAccount();
  const chainId = useChainId();
  const useData = { account, chainId };
  const [ownerId, setOwnerId] = useState("");
  const [refresh, setRefresh] = useState(false);
  const [allData, setAllData] = useState();

  useEffect(() => {
    const getID = async () => {
      const owner = await getOwner();
      setOwnerId(owner);
    };
    if (chainId !== null && chainId === workingNetwork) {
      getID();
    }
  }, [account, chainId]);
  return (
    <>
      <Header
        userData={useData}
        ownerId={ownerId}
        refresh={refresh}
        allData={(data) => setAllData(data)}
      />
      {/* {account && account.toUpperCase() === ownerId.toUpperCase() && (
        <Form userData={useData} ownerId={ownerId} />
      )} */}
      {account && (
        <Form
          userData={useData}
          ownerId={ownerId}
          refreshPage={() => setRefresh(!refresh)}
          allData={allData}
        />
      )}
      <JoinGroup userData={useData} />
      <Footer />
    </>
  );
}
